// ─────────────────────────────────────────────────────────────────────────────
//  USDD Academy — Weekly Timetable (editable config)
// ─────────────────────────────────────────────────────────────────────────────
//
//  This is the ONLY file you need to edit to change what shows up on:
//   • Homepage "Pick a class" timetable section
//   • /schedule  (full timetable page)
//   • /kids      (kids-only compact timetable)
//   • /workshops (workshops-only compact timetable)
//
//  How to edit a class
//  --------------------
//    1. Find the class object below (they're grouped by day).
//    2. Change any field. Save. The site auto-reloads.
//
//  How to add a new class
//  -----------------------
//    Copy any existing block and edit. Required fields:
//
//      day             "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat" | "Sun"
//      time            "HH:MM – HH:MM"  (use the en-dash "–", not "-")
//      title           "USDD Kids · Juniors"  (shown big)
//      style           "Hip-Hop · Foundations"  (small grey line)
//      level           "Ages 6–10"  or  "Adult · Open"
//      location        "Chatham" | "Medway" | "Elephant & Castle" | "Rotating"
//      category        "adult" | "kids" | "workshop"   ← drives the colour pill
//
//    Optional:
//      appointmentType  Acuity appointment-type ID (number/string). Leave ""
//                       and the modal opens the normal Acuity flow.
//      bookingUrl       Override the booking link — if set, "Reserve" will
//                       open this exact URL in the modal instead of building
//                       one from your Acuity owner ID. Useful for ad-hoc
//                       events, paid workshops, or third-party links.
//
//  How to remove a class
//  ----------------------
//    Delete the object (or comment it out with /* ... */).
//
//  How to re-order
//  ----------------
//    Order inside this array doesn't matter — the UI groups by day
//    (Mon → Sun) and sorts by time automatically.
//
//  Tip: keep one comment line per day so the file stays scannable.
// ─────────────────────────────────────────────────────────────────────────────

export const TIMETABLE = [
  // ── MONDAY ────────────────────────────────────────────────────────────────
  {
    day: "Mon",
    time: "17:30 – 18:30",
    title: "USDD Kids · Juniors",
    style: "Hip-Hop · Foundations",
    level: "Ages 6–10",
    location: "Chatham",
    category: "kids",
    appointmentType: "",
    bookingUrl: "",
  },
  {
    day: "Mon",
    time: "18:45 – 20:00",
    title: "USDD Kids · Teens",
    style: "Hip-Hop · Choreography",
    level: "Ages 11–17",
    location: "Chatham",
    category: "kids",
    appointmentType: "",
    bookingUrl: "",
  },
  {
    day: "Mon",
    time: "20:00 – 21:30",
    title: "Hip-Hop Foundations",
    style: "Hip-Hop",
    level: "Adult · Open",
    location: "Chatham",
    category: "adult",
    appointmentType: "",
    bookingUrl: "",
  },

  // ── TUESDAY ───────────────────────────────────────────────────────────────
  {
    day: "Tue",
    time: "19:00 – 20:30",
    title: "Afro Dance",
    style: "Afro · Choreography",
    level: "Adult · All levels",
    location: "Elephant & Castle",
    category: "adult",
    appointmentType: "",
    bookingUrl: "",
  },

  // ── WEDNESDAY ─────────────────────────────────────────────────────────────
  {
    day: "Wed",
    time: "18:00 – 19:00",
    title: "USDD Kids · Performance",
    style: "Performance · Audition group",
    level: "Ages 9–17",
    location: "Medway",
    category: "kids",
    appointmentType: "",
    bookingUrl: "",
  },
  {
    day: "Wed",
    time: "19:15 – 20:45",
    title: "Dancehall",
    style: "Dancehall",
    level: "Adult · All levels",
    location: "Medway",
    category: "adult",
    appointmentType: "",
    bookingUrl: "",
  },

  // ── THURSDAY ──────────────────────────────────────────────────────────────
  {
    day: "Thu",
    time: "19:00 – 20:30",
    title: "Krump",
    style: "Krump",
    level: "Adult · Intermediate",
    location: "Elephant & Castle",
    category: "adult",
    appointmentType: "",
    bookingUrl: "",
  },

  // ── FRIDAY ────────────────────────────────────────────────────────────────
  {
    day: "Fri",
    time: "19:30 – 21:00",
    title: "Freestyle & Battle Training",
    style: "Freestyle · Cypher",
    level: "Adult · Intermediate+",
    location: "Chatham",
    category: "adult",
    appointmentType: "",
    bookingUrl: "",
  },

  // ── SATURDAY ──────────────────────────────────────────────────────────────
  {
    day: "Sat",
    time: "11:00 – 12:00",
    title: "USDD Kids · All-Stars",
    style: "Multi-style showcase prep",
    level: "Ages 8–17 · Audition",
    location: "Chatham",
    category: "kids",
    appointmentType: "",
    bookingUrl: "",
  },
  {
    day: "Sat",
    time: "14:00 – 16:00",
    title: "Monthly Workshop",
    style: "Guest teacher",
    level: "Workshop · All levels",
    location: "Rotating",
    category: "workshop",
    appointmentType: "",
    bookingUrl: "",
  },
  {
    day: "Sat",
    time: "16:30 – 18:00",
    title: "Amapiano",
    style: "Amapiano",
    level: "Adult · All levels",
    location: "Chatham",
    category: "adult",
    appointmentType: "",
    bookingUrl: "",
  },
];

// ─────────────────────────────────────────────────────────────────────────────
//  Filter pills shown above the /schedule + homepage timetable.
//  Edit labels here if you want different wording.
// ─────────────────────────────────────────────────────────────────────────────
export const TIMETABLE_FILTERS = [
  { id: "all", label: "All classes" },
  { id: "adult", label: "Adults" },
  { id: "kids", label: "Kids" },
  { id: "workshop", label: "Workshops" },
];

// Day order for sorting / grouping in the UI. Don't change unless you also
// want to change which day is shown first.
export const DAY_ORDER = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
